export default "__VITE_ASSET__DYitGOvM__"